import React, { ReactElement } from "react";
import classNames from "classnames";
import { DropdownItem } from "Components/ReactstrapSlim";
import { ArrowLeftAlt } from "Components/Icons";

import dropdownClasses from "./ClearDropdown.module.scss";
import classes from "./SolutionsDropdown.module.scss";

interface SolutionCardProps {
   icon: ReactElement;
   title: string;
   description: string;
   actionText: string;
   action: () => void;
   className?: string;
}

const SolutionCard: React.FC<SolutionCardProps> = ({
   icon,
   title,
   description,
   actionText,
   action,
   className,
}) => {
   return (
      <div className={classNames(classes.cardContainer, className)}>
         {React.cloneElement(icon, { className: classes.cardIcon })}
         <div className={classes.cardTitle}>{title}</div>
         <div className={classes.cardDescription}>{description}</div>
         <DropdownItem
            cssModule={dropdownClasses}
            className={classNames(classes.cardAction, "btn btn-link")}
            onClick={action}
         >
            <span className={classes.cardActionText}>{actionText}</span>
            <ArrowLeftAlt className={classes.cardActionIcon} />
         </DropdownItem>
      </div>
   );
};

export default SolutionCard;
